// src/services/usersService.ts
import { db, now } from "../firebase/firestore";
import {
  collection,
  getDocs,
  limit,
  orderBy,
  query,
  startAfter,
  updateDoc,
  doc,
  where,
  type QueryDocumentSnapshot,
  type DocumentData,
} from "firebase/firestore";
import { parseRole, type Role } from "../models/auth";

export interface UserListItem {
  uid: string;
  email: string;
  fullName?: string;
  role: Role; // ← SIEMPRE definido en la salida
  createdAt?: unknown;
  updatedAt?: unknown;
  phone?: string;
  address?: string;
  age?: number;
  photoURL?: string | null;
}

export interface Page<T> {
  items: T[];
  next: QueryDocumentSnapshot<DocumentData, DocumentData> | null;
}

export interface ListUsersOpts {
  role?: Role; // si viene, filtramos por rol
}

export async function listUsersPage(
  pageSize = 20,
  cursor?: QueryDocumentSnapshot<DocumentData, DocumentData>,
  opts?: ListUsersOpts
): Promise<Page<UserListItem>> {
  const usersRef = collection(db, "users");

  const parts = [
    ...(opts?.role ? [where("role", "==", opts.role)] : []),
    orderBy("createdAt", "desc"),
    ...(cursor ? [startAfter(cursor)] : []),
    limit(pageSize),
  ];

  const q = query(usersRef, ...parts);
  const snap = await getDocs(q);

  const items: UserListItem[] = snap.docs.map((d) => {
    const data = d.data();
    const role = parseRole(data.role) ?? "user"; // ← normalizamos a "user"
    const item: UserListItem = {
      uid: d.id,
      email: String(data.email ?? ""),
      role,
    };
    if (typeof data.fullName === "string" && data.fullName.length)
      item.fullName = data.fullName;
    if (typeof data.phone === "string" && data.phone.length)
      item.phone = data.phone;
    if (typeof data.address === "string" && data.address.length)
      item.address = data.address;
    if (typeof data.age === "number") item.age = data.age;
    if (typeof data.photoURL === "string" || data.photoURL === null)
      item.photoURL = data.photoURL;
    if (data.createdAt !== undefined) item.createdAt = data.createdAt;
    if (data.updatedAt !== undefined) item.updatedAt = data.updatedAt;
    return item;
  });

  let next: QueryDocumentSnapshot<DocumentData, DocumentData> | null = null;
  if (snap.docs.length === pageSize && snap.docs.length > 0) {
    next = snap.docs[snap.docs.length - 1] as QueryDocumentSnapshot<
      DocumentData,
      DocumentData
    >;
  }
  return { items, next };
}

export async function updateUserRole(uid: string, role: Role): Promise<void> {
  await updateDoc(doc(db, "users", uid), { role, updatedAt: now() });
}
